module.exports = __webpack_public_path__ + "img/head-girl.2774002a.png";